<template>
    <div>
      <top-navbar></top-navbar>
      <div class="mb-5 background_color">
        <h6 class="manage-boder pt-2 font1  decoration"> <router-link class="decoration" to="/"> {{language[1]['Home']}} </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>  {{language[7]['Manage Users']}} </h6>
  
        <!-- <p v-for="(permission, index) in this.permissions" :key="index">
        {{ permission.permission_name }}
      </p> -->
      <!-- {{ this.permissions }} -->
        <div class="container-fluid">
          <div style="border: 0px; padding: 0px; min-height:0px" class="navbar background_color">
            <div class="d-flex">
              <b-input-group size="sm" style="width: 225px;">
                <b-form-input id="filter-input" v-model="filter" @input="loadMiinventory()" type="search" placeholder="Search">
                </b-form-input>
              </b-input-group>
  
              <b-modal :id="infoModal3.id" 
  
  size="sm" 
  > 
  <template #modal-title>
                  <h5>New User Type</h5>
                </template>
  <div>
   
    <v-select   v-model="rolestype" :options="roles"  label="name" ></v-select>
  </div>
  <template #modal-footer>
                  <button style="font-size: small;"  @click="Saveusertype(infoModal3.content)" class="btn btn-outline-primary btn-sm mb-1 mt-0 bdr-rad">Save</button>
                  
                </template>
 </b-modal>
  
          
  
              <div style="margin-top: 11px;" class="ms-2">
                <span class="custom-breadcrumb"><b>{{language[11]['Showing ']}} {{currentPage}}-{{currentPage * perPage}} {{language[12]['of ']}} {{totalRows}} {{language[13]['items']}}.</b></span>
              </div>
  
            
            </div>
  
            <div class="d-grid gap-2 d-md-flex justify-content-md-end">
              <button @click="UserType()" class="btn btn-outline-primary btn-sm mb-1 mt-0 bdr-rad">{{language[104]['Manage User Type']}}</button>
              <button @click="UserCreate()" class="btn btn-outline-primary btn-sm mb-1 mt-0 bdr-rad"> {{language[79]['Create User']}}</button>
              <div>
               
              </div>
            </div>
          </div>

  
          <div class="card bdr-rad2 mt-1 shadow p-2">
            <div class="card-body ">
              <div class="d-flex justify-content-center" v-if="isLoading">
                <div class="spinner-border text-primary" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>
              <div v-else>
                <div class="table-responsive ">
                  <b-table  
    responsive
    style="font-size: small;"
    class="table-hover"
    :items="all_datas"
     :fields="fields"
     :current-page="currentPage"
     head-variant="dark"           
      :filter="filter"
       :filter-included-fields="filterOn"
         :sort-by.sync="sortBy"
         :sort-desc.sync="sortDesc"
         :sort-direction="sortDirection"
         show-empty
       small
     >
   
  
  
      <!-- <template #cell(C_name)="row">
        {{ row.value.first }} {{ row.value.last }}
      </template> -->
  
      
      <template #cell(actions2)="row">
      
        <div class="dropdown">
  <button class="btn btn-sm btn-outline-primary dropdown-toggle bdr-rad" type="button" data-toggle="dropdown" aria-expanded="false">
    {{language[77]['Action']}}
  </button>
  <div class="dropdown-menu bdr-rad">
    <a class="dropdown-item mouse-cursor" @click="UpdatePassword(row.item.id)" >{{language[78]['Update']}}</a>
    <a class="dropdown-item mouse-cursor"@click="Permissions(row.item.id)">{{language[66]['Permissions']}}    </a>
    <a class="dropdown-item mouse-cursor"@click="changeUsertype(row.item.id)">{{language[105]['Change User Type']}}    </a>
    <a class="dropdown-item mouse-cursor"  v-if="row.item.statusvalue==1" @click="inactive(row.item.id)">{{language[56]['Inactive']}}</a>
    <a class="dropdown-item mouse-cursor" v-if="row.item.statusvalue==2" @click="active(row.item.id)">{{language[55]['Active']}}</a>
  
   
  </div>
</div>







      </template>
  
      <template #cell(number)="row">
                   {{ row.index + 1 === 10 ? currentPage * 10 : (currentPage - 1)*10 + row.index + 1 }} 
                    </template>
      <template #cell(P_code1)="row">
       <a href="/" > {{ row.item.P_code }}</a>
  </template>
  
     
    </b-table>
  
                  <b-col style="padding-left: 0px;" sm="7" md="2" class="my-1 mb-4">
                    <b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" size="sm"></b-pagination>
      </b-col>
                </div>
              </div>
            </div>
          </div>
          <br><br>
        </div>
      </div>
      <content-footer></content-footer>
    </div>
  </template>
  
    
    <script>
   
   import axios from 'axios';
   import authService from '@/auth.service';
   import httpClient from '@/axios';
   import TopNavbar from './../../layout/TopNavbar.vue';
   import ContentFooter from './../../layout/ContentFooter.vue'
  import DatePicker from 'vue2-datepicker';
  import vSelect from 'vue-select';
   import 'vue2-datepicker/index.css';
    
    
    
    export default {
      components :{
        'v-select': vSelect,
          TopNavbar,
          ContentFooter,
          DatePicker,
          
      },
      created(){
        this.loadMiinventory();
        this.loadCat();
      },
    
        mounted(){
          this.fields= [
          { key: 'number', label: '#', sortable: true, sortDirection: 'desc' },
          { key: 'username', label: this.language[60]['Username'], sortable: true,  },
          { key: 'usertype', label: this.language[61]['User type'], sortable: true,  },
          { key: 'email', label: this.language[76]['Email'], sortable: true,  },
          { key: 'status', label: this.language[22]['Status'], sortable: true,  },
        //   { key: 'PC_description', label: 'Product Category', sortable: true  },
        //   { key: 'P_code1', label: 'Product Code', sortable: true  },
        //   { key: 'P_description', label: 'Product Description', sortable: true  },
        //   { key: 'P_internal_selling_price', label: 'Selling Price (Rs)', sortable: true  },
        //   { key: 'status', label: 'Status', sortable: true  },
        //   { key: 'P_created_date', label: 'Created Date', sortable: true ,  },
         
        // { key: 'actions', label: '', class:'width-custom3', },
        // { key: 'actions1', label: '', class:'width-custom3', },
          { key: 'actions2', label: this.language[24]['Actions'], class:'width-custom2', }
        ];
        },
       
        computed: {
          
    
    
    
        },
    
        data() {
      return {
        currentPage: 1,
        mcustomers:[],
        all_datas:[],
      search: "",
      access_token:authService.isLoggedIn(),
        userid:authService.isUserid(),
        permissions:authService.isPermission(),
        language:JSON.parse(authService.isLanguage()),
        sortBy: '',
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
          FromDate: null,
          ToDate: null,
        filterOn: [],
        roles:[],
        totalRows: '',
        rolestype: '',
        
        perPage:15,
        pageOptions: [5, 10, 15, { value: 100, text: "Show a lot" }],
        fields:[],
      
          
        infoModal: {
          id: 'info-modal',
          title: '',
          content: {},
        },
        infoModal3: {
          id: 'info-modal3',
          title: '',
          content: [],
        },
        isLoading: true, 
    
       
      };
      },
    
  
   
  
    
        
    
    
       methods:{ 
  
  

        async Saveusertype(id) {
    
    
   
    try {
      const { data} = await  httpClient.post('/web/api/user/changeusertype?id='+id,{rolestype:this.rolestype},{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
      if(data.status == 200){
        window.location.reload();
      }
       
      
    } catch (error) {
      console.log(error.response);
    }
  },


  
        async loadCat() {
    
    console.log(this.issue);
   
    try {
      const { data} = await  httpClient.get('/web/api/user/loadroalper1',{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       this.roles = data.roles;
       
      
    } catch (error) {
      console.log(error.response);
    }
  },
  
  
  
  
  
  
    
      async info(idCustomer) {
    console.log(idCustomer);
    try {
      const { data} = await  httpClient.get('/web/api/mcustomer/view?id='+idCustomer,{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       this.infoModal.content = data.item_list
       this.$root.$emit('bv::show::modal', this.infoModal.id)
      
      
    } catch (error) {
      console.log(error.response);
    }
  },
    async moreinfo(idproduct) {
  
  this.$router.push('/mproduct/view?id='+idproduct);
  
  },
    async Permissions(id) {
  
  this.$router.push('/user/permission?id='+id);
  
  },
    async changeUsertype(id) {
  
      this.infoModal3.content = id;
      this.$root.$emit('bv::show::modal', this.infoModal3.id);
  
  },
    async UpdatePassword(id) {
  
  this.$router.push('/user/updatepassword?id='+id);
  
  },
  async UserCreate() {
  
  this.$router.push('/user/create');
  
  },
  async UserType() {
  
  this.$router.push('/usertype/index');
  
  },
  async Update(id){
      this.$router.push('/mproduct/update?id='+id);
    },
  
    serchCustom(id) {
  
  this.filterOn = id;
  },
      // onFiltered(filteredItems) {
      //     // Trigger pagination to update the number of buttons/pages due to filtering
      //     this.totalRows = filteredItems.length
      //     console.log(totalRows);
      //     this.currentPage = 1
      //   },
    
        async loadMiinventory(page = this.currentPage) {
          // const storedPermissions = this.permissions;
          // const permissionsArray = JSON.parse(storedPermissions);
          // console.log(permissionsArray);
          // console.log("aaaaaaaddd");
         
      
        try {
          const { data} = await  httpClient.get('/web/api/user/index',{
  
            params: {
              page: page,
              perPage: this.perPage,
              filter: this.filter,
              FromDate: this.FromDate,
              ToDate: this.ToDate,
            },
            headers:{
              'Authorization':'Bearer '+this.access_token,
              'Content-type': 'application/json',
             
            }
           });
           console.log(data);
           this.all_datas = data.all_data;
          this.totalRows = data.total_count;
          this.currentPage = data.page;
          this.isLoading = false;
          
        } catch (error) {
          console.log(error.response);
        }
      },
  
      pageChanged(page) {
        console.log(page);
       this.loadMiinventory(page);
   },


   async active(id) {
       
      
        try {
          const { data} = await  httpClient.post('/web/api/user/active',{id:id},{
            headers:{
              'Authorization':'Bearer '+this.access_token,
              'Content-type': 'application/json',
             
            }
           });
           console.log(data);
         if(data.status==200){
           this.loadMiinventory();
         }
           
            
          
        } catch (error) {
          console.log(error.response);
        }
      },
   async inactive(id) {
       
      
        try {
          const { data} = await  httpClient.post('/web/api/user/inactive',{id:id},{
            headers:{
              'Authorization':'Bearer '+this.access_token,
              'Content-type': 'application/json',
             
            }
           });
           console.log(data);
         if(data.status==200){
           this.loadMiinventory();
         }
           
            
          
        } catch (error) {
          console.log(error.response);
        }
      },
  
  
      
       
    
     
    
    
    
    
    
    }
    
    
    
    };
    
    </script>
    
    <style >
  
  
    .button1{
      width: 10px !important;
    }
    .border1{
      border: none;
      background-color: #0d6efd;
    }
    .font-color1:hover{
      color: black !important;
      cursor: pointer;
    }
    .manage-boder{
      border-bottom: 1px solid #E9E9E3;
      border-top: 1px solid #E9E9E3;
    }
    .border-radius0{
          border-radius:0px !important ;
    }
    .font1{
          font-size: 13px !important;
       
        }
        .font-bold1{
          font-weight: bold;
        }
        .manage-boder{
        border-bottom: 2px solid #E9E9E3;
        border-top: 2px solid #E9E9E3;
        padding-bottom: 10px !important;
        padding-top: 10px !important;
        
        }
        .font1{
          font-size: 13px !important;
       
        }
        .font-bold1{
          font-weight: bold !important;
        }
        .colr1{
            color:#A5A5A3;
            
        }
        .decoration{
        text-decoration: none;
        color:#A5A5A3  ;
      }
      .width7{
        width: 250px;
      }
      .bg-mycoolor{
        background-color: #a4d2f3 !important;
  
      }
     
    .modal-footer{
      text-align: right !important;
      display: block;
    }
  
    .pfimg3 {
    padding-left: 10px;
  }
  .decoration {
    text-decoration: none;
  }
  .width-custom3 {
    width: 180px;
  }
  .date-placeholder {
    position: absolute;
    top: 5px;
    left: 12px;
    pointer-events: none;
    color: #6c757d;
  }

  .dropdown-shadow {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15); /* Adjust the shadow as needed */
}

.dropdown-shadow .dropdown-menu {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}
    
    </style>